import { render } from "./Index.vue?vue&type=template&id=6330c414&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6330c414&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6330c414"

export default script